import { CheckSquare, Edit, Linkedin, Mail, Square, Trash, X } from "react-feather"
import ItemPersonDTO from "../../DTO/ItemPersonDTO"
import mainservice from "../../../services/MainService"
import { EventDTO } from "../../DTO/EventDTO"
import { useEffect, useState } from "react"
import './Person.scss'
import { PersonBubble } from "./PersonBubble"
import EventList from "../Event/EventList"
import { PublishKind } from "../../models/publishKinds"
import InputB from "../../../components/InputB/InputB"
import { DisplayCustomerName } from "../Customer/Customer";
import ItemCustomerDTO from "../../DTO/ItemCustomerDTO"
import { LexwareButton } from "../Lexware/LexwareButton"
import { TagSelector } from "../tags/TagSelector"
import { TagDTO, TagType } from "../../DTO/TagDTO"
import InlineMenu from "../../elements/InlineMenu"
import MailIcon from '@mui/icons-material/Mail';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LanguageIcon from '@mui/icons-material/Language';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import { Avatar, Box, Button, Card, Checkbox, Grid, Link, Stack } from "@mui/material"

export default function Person(props: {
  item: ItemPersonDTO,
  onClick?: (id: number, item: ItemPersonDTO) => void,
  className?: string,
  onTrash?: (id: number) => void,
  onRemove?: () => void,
  propTrainerTagParent?: EventDTO,
  personTagParent?: EventDTO,
  compact?: '' | 'yes' | 'medium' | 'bubble' | 'joinedEvents' | 'printList1',
  prefix?: string,
  select?: () => void,
  selected?: boolean,
  cb?: () => void,
}) {
  const item = props.item
  const name = <>{item.getDisplayName()}</>
  const [selected, setSelected] = useState(props.selected || false)
  const participationClass = props.personTagParent?.getPropV1('participationProp', `${item.id}`)
  useEffect(() => {
    if (props.selected !== undefined) {
      setSelected(props.selected)
    }
  }, [props.selected])
  if (props.compact === 'printList1') {
    return <div style={{pageBreakAfter: 'always'}}>
      <div style={{display: 'flex'}}>
        <h1>
          {item.getDisplayName()}
        </h1>
        <div>
          {[item.getPropV1('data', 'birthdate')].filter(i => i).join(', ')}
        </div>
        <div>
          <EventTag
            person={{id: item.id}}
            parent={props.personTagParent}
            className='w3-margin-left w3-margin-top w3-margin-bottom'
            standardValue='none'
            key1='participationProp'
            types={ParticipationTypes}
            cb={props.cb}
          />
          {
            props.personTagParent && props.personTagParent.getPropV1('data', 'individualBookable') === '1' &&
            <EventTag
              person={{id: item.id}}
              parent={props.personTagParent}
              className='w3-margin-left w3-margin-top w3-margin-bottom'
              standardValue='none'
              key1='personPayedProp'
              types={PaymentTypes}
            />
          }
        </div>
      </div>
      <div>
          {
            item.customers && item.customers.length > 0 &&
            <>
              {item.customers.map((c, index) =>{
                return <div
                  key={`person-print-customer-${item.id}-${c.id}`}
                >                
                  {c.name}
                </div>
              })}
            </>
          }
        </div>
      <div style={{
        display: 'flex',
        width: '100%',
        alignContent: 'stretch',
        alignItems: 'start',
        gap: '1rem',
      }}>
        <div style={{
          width: '50%',
          marginTop: '2rem',
        }}>
          {
                props.personTagParent &&
                <>
                  <PersonEventNotesDisplay
                    key1={"personNotes"}
                    name={"Notizen"}
                    personId={item.id}
                    event={props.personTagParent}
                  />
                  <div className='w3-margin-top'>
                    <PersonEventNotesDisplay
                      key1={"personCancelNotes"}
                      name={"Absagegrund"}        
                      personId={item.id}
                      event={props.personTagParent}
                    />
                  </div>
                </>
              }
        </div>

        
        <div>
          <h2>Adresse (Privat)</h2>
          <div>Straße: {item.getPropV1('privateInfo', 'street') || '-'}</div>
          <div>Stadt: {item.getPropV1('privateInfo', 'town') || '-'}</div>
          <div>E-Mail: {[item.email, item.getPropV1('info', 'PRIVATEMAIL')].filter(i => i).join(' / ') || '-'}</div>
          <div>Mobil: {item.getPropV1('info', 'Mobil1') || '-'} / {item.getPropV1('privateInfo', 'mobile') || '-'}</div>
        </div>
      </div>
      
     
      <div>
        <h2>Teilgenommen an</h2>
        <EventList
          personId={item.id}
          onSelect={() => {}}
          compact={'participated'}
          blacklist={[props.personTagParent?.id || -1]}
          publishKind={PublishKind.isSeminar}
          ignoreDate='ignore'
        />
      </div>
    </div>
  }
  if (props.compact === 'bubble') {
    return <PersonBubble item={item} onClick={props.onClick} />
  }
  if (props.compact === 'medium') {
    return <div
      className={`STPerson PTListItem ${props.className || ''} ${participationClass}`}
      onClick={() => {
        console.log('person click')
        if (props.select) {
          console.log(' select')
          props.select()
        } else if (props.onClick) {
          props.onClick(item.id, item)
          mainservice.navTo([['view', 'spPersonEdit'], ['id', item.id]])
          return
        }
      }}
    >
      <Box>
        { props.select &&
          <Checkbox
            checked={selected}
          />
        }
      </Box>
      <div
        className={`w3-button w100 textLeft`}>
        
        <div className='display-name'>{name}</div>
        {
          item.customers && item.customers.length > 0 &&
          <>
            {item.customers.map((c, index) =>{
              return <div
                key={`person-customer-${item.id}-${c.id}`}
                className='regularWeight'
              >
                  {c.name}
                
              </div>
            })}
          </>
        }
      </div>
    </div>
  }
  if (props.compact === 'joinedEvents') {
    return <Card variant="outlined" sx={{ marginBottom: 2, padding: 2}}>
      <Grid container spacing={2} sx={{ marginBottom: 2}}>
        <Grid size={{ xs: 4, md: 2}} className='avatar'>
          <Card variant="outlined" sx={{ height: '100%'}}>
            <Stack
              direction="column"
              spacing={0}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                height: '100%'
              }}
            >
              <Avatar sx={{  width: 42, height: 42, margin: 'auto' }}>{item.getInitials()}</Avatar>
            </Stack>
          </Card>
        </Grid>
        <Grid size={{ xs: 8, md: 7}} className='generalInfo' sx={{ paddingTop: 2}}>
          <Stack spacing={1}>
            <Box sx={{fontWeight: 'bold'}}>
              {item.getDisplayName()}
            </Box>
            <Box>
              {
                [item.getPropV1('data', 'birthdate')].filter(i => i).join(', ')
              }
            </Box>
            <Stack direction="row">
              Unternehmen:&nbsp;<Stack direction="column">
                {
                  item.customers && item.customers.length > 0 &&
                  <>
                    {item.customers.map((c, index) =>{
                      return <div
                        key={`person-customer-${item.id}-${c.id}`}
                        className='regularWeight'
                      >
                        
                        {c.name}
                      </div>
                    })}
                  </>
                }
              </Stack>
            </Stack>
            <Box>Straße (Privat): {item.getPropV1('privateInfo', 'street')} {item.getPropV1('privateInfo', 'town')}</Box>
            <Box>E-Mail: {[item.email, item.getPropV1('info', 'PRIVATEMAIL')].filter(i => i).join(' / ')}</Box>
            <Box>Mobil (Beruflich / Privat): {item.getPropV1('info', 'Mobil1')} / {item.getPropV1('privateInfo', 'mobile')}</Box>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 3}} className='infoAndNotes' sx={{ paddingTop: 2}}>
          <Card variant="outlined" sx={{ padding: 2}}>
            {
              props.personTagParent &&
              <>
                <PersonEventNotesDisplay
                  key1={"personNotes"}
                  name={"Notizen"}
                  personId={item.id}
                  event={props.personTagParent}
                />
                <div className='w3-margin-top'>
                  <PersonEventNotesDisplay
                    key1={"personCancelNotes"}
                    name={"Absagegrund"}        
                    personId={item.id}
                    event={props.personTagParent}
                  />
                </div>
              </>
            }
          </Card>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6}}>
              <EventTag
                person={{id: item.id}}
                parent={props.personTagParent}
                className='w3-margin-left w3-margin-top w3-margin-bottom'
                standardValue='none'
                key1='participationProp'
                types={ParticipationTypes}
                cb={props.cb}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6}}>
              {
                props.personTagParent && props.personTagParent.getPropV1('data', 'individualBookable') === '1' &&
                <EventTag
                  person={{id: item.id}}
                  parent={props.personTagParent}
                  className='w3-margin-left w3-margin-top w3-margin-bottom'
                  standardValue='none'
                  key1='personPayedProp'
                  types={PaymentTypes}
                />
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Card variant="outlined">
        <EventList
          personId={item.id}
          onSelect={() => {}}
          compact={'participated'}
          blacklist={[props.personTagParent?.id || -1]}
          publishKind={PublishKind.isSeminar}
          ignoreDate='ignore'
        />
      </Card>
    </Card>
  }
  
  if (props.compact) {
    return <span
      onClick={() => {
        mainservice.navTo([['view', 'spPersonEdit'], ['id', item.id]])
      }}
    >{props.prefix || ''}{name}</span>
  }
  return <Box
    className={`STPerson PTListItem flex align-items-top ${props.className || ''} ${participationClass}`}
  >
    { props.select &&
      <Box>
        <Checkbox
          checked={selected}
          onClick={props.select}
        />
      </Box>
    }
    <Stack
      sx={{
        textAlign: 'left',
      }}
    >
      <Button
        className={`w3-button flex-grow textLeft display-name`}
        onClick={() => {
          if (props.onClick) {
            props.onClick(item.id, item)
            return
          }
          mainservice.navTo([['view', 'spPersonEdit'], ['id', item.id]])
        }}
      >{name}</Button>
    </Stack>

    <Stack
      sx={{
        textAlign: 'left',
        minWidth: '250px',
      }}
      direction="column"
    >
      {
        item.customers && item.customers.length > 0 &&
          (
            item.customers.map((c, index) => {
              // eslint-disable-next-line react/jsx-no-undef
              return <Box
                key={`person-customer-${item.id}-${c.id}`}
                
              >
                <Button
                  onClick={() => {
                    if (item.customers.length > 1) {
                      mainservice.navTo([['view', 'spCustomerEdit'], ['id', c.id]])
                    }
                  }}
                  sx={{
                    paddingLeft: 0,
                    justifyContent: 'flex-start',
                  }}
                >
                  <Stack direction="column"
                    sx={{
                      textAlign: 'left',
                      minWidth: '250px',

                    }}
                  >
                    <DisplayCustomerName
                      key={`person-customer-${item.id}-${c.id}`}
                      item={c as ItemCustomerDTO}
                      // lazy
                      // options={[['customerShowCityAndAddress', 'yes']]}
                      
                      options={[['customerShowCityAndAddress', 'yes']]}
                    />
                  </Stack>
                </Button>
                
              </Box>
            })
          )
        }
        { item.email &&
          <Box
            className='flex align-items-center'
          >
            <MailIcon />
            <a
              href={`mailto:${item.email}`}
            >
              {item.email}
            </a>
          </Box>
        }
        { item.getInternetUrl() &&
          <Box
            className='flex align-items-center'
          >
            <a target="_blank" rel="noreferrer" href={item.getInternetUrl()}>
              <LanguageIcon />{item.getInternetUrl()}
            </a>
          </Box>
        }
      </Stack>
    { // Tags
      [
        {
          kind: 'FUNKTIONHOMOGEN',
          mode: 'single'
        },
        {
          kind: 'ABTEILUNGHOMOGEN',
          mode: 'single'
        },
        {
          kind: 'marketingRole',
          mode: 'list'
        },
        {
          kind: 'groupInfo',
          mode: 'list'
        }
      ].map((t, index) => <Box
          key={`person-tag-selector-${item.id}-${t.kind}`}
          sx={{
            paddingBottom: '16px',
            minWidth: '150px',
            paddingLeft: '8px',
          }}
        >
        <TagSelector
          parentId={item.id}
          kind={t.kind as TagType}
          mode={t.mode as 'list' | 'single'}
          selectedTags={item.getTagsByKind(t.kind as TagType, 'tag')}
          selectTag={async (tag: TagDTO, single: boolean) => {
            await item.setTag(tag, true);
          }}
          unsetTag={async (tag: TagDTO) => {
            await item.unsetTag(tag);
          }}
          readMode={false}
        />
        </Box>
      )
    }
    
    {
      props.personTagParent &&
      <div className='width40p flex'>
        <EventTag
          person={item}
          parent={props.personTagParent}
          className='width200px w3-margin-left w3-margin-top w3-margin-bottom'
          standardValue='none'
          key1='participationProp'
          types={ParticipationTypes}
        />
        {
          props.personTagParent && props.personTagParent?.getPropV1('data', 'individualBookable') === '1' &&
          <EventTag
            person={{id: item.id}}
            parent={props.personTagParent}
            className='w3-margin-left w3-margin-top w3-margin-bottom'
            standardValue='none'
            key1='personPayedProp'
            types={PaymentTypes}
          />
        }
        <div>
          <EventTag
            person={item}
            parent={props.propTrainerTagParent}
            className='w3-margin-left w3-margin-top w3-margin-bottom'
            standardValue='trainer'
            key1='trainerProp'
            types={TrainerTypes}
          />
          <ProjectOwnerTag
            person={item}
            parent={props.propTrainerTagParent}
          />
        </div>
        
      </div>
    }
    <Stack>
      {
        item.customers && item.customers.length > 0 &&
        (
          item.customers.map((c, index) => {
            return <Box
              key={`person-customer-box-${item.id}-${c.id}`}
            >
              {
                item.customers.length > 1 &&
                <Box>{c.name}: </Box>
              }
              <LexwareButton
                item={c as ItemCustomerDTO}
                kind='person'
                personId={`${item.id}`}
                reloadTrigger={() => {
                  window.location.reload();

                }}
                buttonSizes="16px"
              />
            </Box>
          })
        )
      }
    </Stack>
    <InlineMenu
      title={
        <MoreVertIcon />
      }
      options={[
        {
          show: true,
          title: 'E-Mail schreiben',
          icon: <MailIcon />,
          disabled: !item.email,
          onClick: (e) => {
            if (!item.email) return
            e?.preventDefault();
            window.location.href = `mailto:${item.email}`;
          }
        },
        {
          show: true,
          title: 'Internet Seite öffnen',
          icon: <LanguageIcon />,
          disabled: !!item.getInternetUrl(),
          onClick: (e) => {
            if (!!item.getInternetUrl()) return
            e?.preventDefault();
            window.open(item.getInternetUrl(), '_blank');
          }
        },
        {
          show: !!props.onTrash,
          title: 'Löschen',
          icon: <DeleteIcon />,
          onClick: () => {
            if (props.onTrash) {
              props.onTrash(item.id)
            }
          }
        },
        {
          show: !!props.onRemove,
          title: 'Entfernen',
          icon: <ClearIcon />,
          onClick: () => {
            if (props.onRemove) {
              props.onRemove()
            }
          }
        },
      ]}
    />
  </Box>
}

type TagItemType = {key: string, name: string}

export const TrainerTypes: TagItemType[] = [
  {
    key: 'managementCoach',
    name: 'Management Coach',
  },
  {
    key: 'seniorCoach',
    name: 'Senior Coach',
  },
  {
    key: 'managementTrainer',
    name: 'Management Trainer*in',
  },
  {
    key: 'seniorTrainer',
    name: 'Senior Trainer*in',
  },
  {
    key: 'trainer',
    name: 'Trainer*in',
  },
  {
    key: 'assitant',
    name: 'Assistent',
  },
]


export const ParticipationTypes: TagItemType[] = [
  {
    key: 'registered',
    name: 'Anmeldung',
  },
  {
    key: 'declined',
    name: 'Absage',
  },
  {
    key: 'canceled',
    name: 'Abgebrochen',
  },
  {
    key: 'reserved',
    name: 'Reservierung',
  },
  {
    key: 'cue',
    name: 'Warteliste',
  },
  {
    key: 'internally',
    name: 'Intern',
  },
]

export const PaymentTypes: TagItemType[] = [
  {
    key: 'none',
    name: 'nicht bezahlt',
  },
  {
    key: 'invoiceSent',
    name: 'Rechnung geschrieben',
  },
  {
    key: 'payed',
    name: 'bezahlt',
  }
]

// Tags which are saved for a person in combination with an event
// key1 examples:
//  trainerProp = Kind of Trainer
//  participationProp = Kind of participation
export function EventTag(props: {
  person: {id: number},
  parent?: EventDTO | ItemPersonDTO,
  standardValue: string,
  key1: string,
  key2?: string,
  className?: string,
  types: TagItemType[],
  cb?: () => void,
}) {
  const parent = props.parent
  const person = props.person
  const key1 = props.key1 //'trainerProp'
  const key2 = props.key2 || `${person ? person.id : -1}`
  const standardValue = props.standardValue
  const [currentValue, setCurrentValue] = useState(parent ? parent.getPropV1(key1, key2) : standardValue || standardValue)
  if (!parent) {
    return null
  }
  
  return <select
      value={currentValue}
      onChange={async (event) => {
        const newValue = event.target.value
        setCurrentValue(newValue)
        await parent.addProp(key1, key2, newValue)
        props.cb && props.cb()
      }}
      className={props.className || ''}
    >
      {
        props.types.map((tt, index) => {
          return <option
            key={`person-types-${key1}-${person.id}-${tt.key}-${index}`}
            value={tt.key}
          >{tt.name}</option>
        })
      }
    </select>
}

export function PersonEventNotesDisplay(props: {
  personId: number,
  event: EventDTO,
  className?: string,
  name: string,
  key1: string,
}) {
  enum Status {
    start,
    edit,
    view,
    saving,
  }
  const key1 = props.key1
  console.log('### key1', key1)
  const key2 = `${props.personId}`
  const [status, setStatus] = useState(Status.start)
  const [content, setContent] = useState(props.event.getPropV1(key1, key2) || '')
  if (status === Status.start) {
    return <div className='lightFont'>
      <label
        onClick={() => {
          setStatus(Status.edit)
        }}
      >
        {props.name}
      </label>
      <div className={content ? 'w3-white w3-padding w3-margin' : ''} dangerouslySetInnerHTML={{__html: content}}></div>
    </div>
  }
  if (status === Status.edit) {
    return <div>
      <button
        className={`w3-button`}
        onClick={() => {
          setStatus(Status.start)
        }}
      >{props.name} schließen</button>
      <InputB
        value={content}
        returnVal={(content: string) => {
          console.log('save the content', content, key1, key2)
          props.event.addProp(key1, key2, content)
          setContent(content)
        }}
        type={'textarea'}
        multiline
      />
    </div>
  }
  return null
}

export function EventTagDisplay(props: {
  personId: number,
  event: EventDTO,
  className?: string,
}) {
  const key1 = 'participationProp'
  const key2 = `${props.personId}`
  const participationKey = props.event.getPropV1(key1, key2) || 'registered' // HIER MUSS REGISTERED STEHEN
  const participationName = ParticipationTypes.find(pt => pt.key === participationKey)?.name || 'nicht teilgenommen'
  const currentId = mainservice.nav.getVal('id') as number
  const showParticipationDD = props.event.id === currentId

  return <div className={`${props.className || ''}`}>
    {showParticipationDD ?
      <>
        
      </>
      : participationName
    }
  </div>
}

export function ProjectOwnerTag(props: {
  person: ItemPersonDTO,
  parent?: EventDTO
}) {
  const parent = props.parent
  const person = props.person
  const key1 = 'projectOwner'
  const key2 = `${person ? person.id : -1}`
  const [currentValue, setCurrentValue] = useState(parent ? parent.getPropV1(key1, key2) : 'no')
  if (!parent) {
    return null
  }
  function click () {
    const newValue = currentValue === 'yes' ? 'no' : 'yes'
    setCurrentValue(newValue)
    if (parent) {
      parent.addProp(key1, key2, newValue)
    }
  }
  return <>
  <button
    className='invisble-button'
    onClick={click}
    >
    {
      currentValue === 'yes' ? <CheckSquare /> : <Square />
    }
    <span className='text-after-icon'>
      Projektverantwortlich
    </span>
    </button>
  </>
}
